<template>
  <div>
    <q-btn
      icon="content_copy"
      small
      flat
      color="primary"
      v-clipboard:copy="text"
      v-clipboard:success="handleClipboardSuccess"
      v-clipboard:error="handleClipboardError"
    >
      {{ $t('copy') }}
    </q-btn>

    <div>
      <q-tooltip v-model="showTooltip" anchor="top middle" self="bottom middle" :offset="[0, 30]">
        {{ $t('copied') }}
      </q-tooltip>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      text: {
        type: String,
        required: true
      }
    },

    data () {
      return {
        showTooltip: false
      }
    },

    methods: {
      handleClipboardSuccess () {
        // Kind of hacky, but looks fancy
        this.showTooltip = true

        setTimeout(() => {
          this.showTooltip = false
        }, 400)
      },

      handleClipboardError () {
        this.$q.notify({ message: this.$t('copy_failed'), type: 'positive' })
      }
    }
  }
</script>
